(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .controller('HubspotLeadDialogController', HubspotLeadDialogController);

    HubspotLeadDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'HubspotLead', 'User'];

    function HubspotLeadDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, HubspotLead, User) {
        var vm = this;

        vm.hubspotLead = entity;
        vm.clear = clear;
        vm.save = save;
        vm.users = User.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.hubspotLead.id !== null) {
                HubspotLead.update(vm.hubspotLead, onSaveSuccess, onSaveError);
            } else {
                HubspotLead.save(vm.hubspotLead, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('valueconnectApp:hubspotLeadUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
